import { createTranslations } from '@npco/utils-translations'

export const corporateCardSettingsWalkthroughTranslations = createTranslations({
  editOutstandingExpensesTitle: 'You can now manage expense definitions',
  editOutstandingExpensesContent:
    'Define expense transaction requirements for employees by determining whether receipts, notes and categories are required.',
})
